import { toast } from "react-toastify";

import { currencies } from "@config/config";

import { resetApp, updateApp, changeCurrency } from "./actions";

const initialAppState = {
  currency: "CURRENCY.EUR",
  currencyName: "EUR",
  symbol: "€",
  currenciesLoaded: false,
  currencies,
};

export const appSlice = (set, gets) => ({
  ...initialAppState,
});

export const appActions = (set, get) => ({
  [resetApp]: () => {
    set((state) => ({
      ...state,
      app: {
        ...initialAppState,
      },
    }));
  },
  [updateApp]: (props) => {
    set((state) => ({
      ...state,
      app: {
        ...state.app,
        ...props,
      },
    }));
  },
  [changeCurrency]: (currency) => {
    set((state) => {
      if (currency.length !== 3) {
        toast.error(`This ${currency} is not valid`);
      } else {
        const newCurrency = get().app.currencies.filter(
          (c) => c.CurrencyName === currency.toUpperCase(),
        )[0];
        return {
          ...state,
          app: {
            ...state.app,
            currencyName: newCurrency.CurrencyName,
            currency: newCurrency.Currency,
            symbol: newCurrency.Symbol,
          },
        };
      }
    });
  },
});
